import React from 'react';

import { IconProps } from './types';

export const CrownIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="48"
        viewBox="0 0 48 48"
        width="48"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M41.3438 32.4473C42.2188 32.2207 43.1329 32.8262 43.1973 33.7285C43.338 35.6797 42.7931 37.3379 41.5645 38.5664C38.7149 41.4004 30.4356 42 24.0001 42C17.5645 42 9.28524 41.4004 6.43563 38.5644C5.20711 37.3359 4.66219 35.6797 4.80281 33.7266C4.86727 32.8262 5.78133 32.2207 6.65633 32.4473C10.1954 33.3652 16.1622 34.5 24.0001 34.5C31.838 34.5 37.8048 33.3652 41.3438 32.4473ZM5.71883 29.0644C5.295 28.9375 4.95125 28.6387 4.77938 28.2324C3.25789 24.6191 1.5157 17.8164 5.95516 11.1758C6.28524 10.6641 6.90047 10.4102 7.48446 10.5293C11.0391 11.2344 13.9942 13.4395 15.795 15.1055C16.8009 12.3301 18.9298 7.91992 23.0977 4.80078C23.627 4.40625 24.3731 4.40625 24.9005 4.80078C29.0704 7.92187 31.1993 12.332 32.2032 15.1055C34.004 13.4395 36.9591 11.2344 40.5138 10.5293C41.0977 10.4102 41.713 10.6641 42.0431 11.1758C46.4825 17.8164 44.7403 24.6191 43.2188 28.2324C43.047 28.6406 42.7032 28.9395 42.2794 29.0664C39.4298 29.9141 32.9513 31.5 24.0001 31.5C15.0489 31.5 8.57039 29.9141 5.71883 29.0644Z"
          fill="url(#paint0_linear_40000422_64220)"
        />
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint0_linear_40000422_64220"
            x1="39.4909"
            x2="4.8"
            y1="5.45455"
            y2="40.1455"
          >
            <stop stopColor="#82C7FF" />
            <stop offset="1" stopColor="#2481CC" />
          </linearGradient>
        </defs>
      </svg>
    );
  },
);
